export const HEADER_TITLE = 'Domestic Money Transfer'
